export const styles = {
  content: {
    maxWidth: 450,
    "& .MuiBox-root": {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      gap: "10px",
      minHeight: 40,
      "& span": {
        height: 40,
        width: 40,
      },
    },
  },
  action: {
    justifyContent: "end",
    gap: "14px",
  },
  joinBtn: {
    width: "108px",
    height: "38px",
  },
  cancelBtn: {
    width: "127px",
    height: "38px",
  },
};
